import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Check, ArrowRight, ArrowLeft } from 'lucide-react';
import { SectionHeader, PremiumCard, Placeholder } from './ui';
export function Includes() {
  const items = ['7 noches de alojamiento premium en Pousada Dois Irmãos.', '10 inmersiones embarcadas en los mejores puntos.', 'Desayunos tropicales y almuerzos ligeros.', 'Traslados in/out en la isla.', 'Guías expertos bilingües (Español/Portugués).', 'Tanques (Aire/Nitrox) y plomos.', 'Asesoramiento previo al viaje.', 'Cena de bienvenida y despedida.'];
  return <section className="py-24 bg-noronha-graphite/50 border-t border-noronha-petroleum/20" data-id="element-85">
      <div className="container mx-auto px-6" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-87">
          <div data-id="element-88">
            <SectionHeader eyebrow="El Programa" title="El viaje incluye" align="left" className="mb-10" data-id="element-89" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-90">
              {items.map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.05
            }} className="flex items-start gap-3" data-id="element-91">
                  <div className="mt-1 bg-noronha-emerald/20 p-1 rounded-full" data-id="element-92">
                    <Check className="w-4 h-4 text-noronha-emerald" data-id="element-93" />
                  </div>
                  <span className="text-noronha-text-body text-sm leading-relaxed" data-id="element-94">
                    {item}
                  </span>
                </motion.div>)}
            </div>
          </div>
          <div className="relative" data-id="element-95">
            <Placeholder type="image" aspectRatio="square" label="Imagen de Grupo / Barco" className="w-full" data-id="element-96" />
            <div className="absolute -bottom-6 -left-6 bg-noronha-volcanic p-6 rounded-2xl border border-noronha-petroleum/30 hidden md:block" data-id="element-97">
              <p className="font-heading text-2xl text-noronha-text-heading" data-id="element-98">
                12
              </p>
              <p className="font-mono text-xs text-noronha-gold uppercase tracking-widest" data-id="element-99">
                Cupos Máximos
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function DiveSpotsSlider() {
  const spots = [{
    name: 'Corveta V17 Ipiranga',
    desc: 'Un naufragio intacto considerado uno de los mejores del mundo.',
    depth: '60m',
    vis: '40m+'
  }, {
    name: 'Pedras Secas',
    desc: 'Un anfiteatro volcánico lleno de vida, túneles y cañones.',
    depth: '18m',
    vis: '30m+'
  }, {
    name: 'Cabeço das Cordas',
    desc: 'Estación de limpieza de tortugas y refugio de tiburones.',
    depth: '25m',
    vis: '35m+'
  }, {
    name: 'Ilha do Meio',
    desc: 'Corrientes suaves y formaciones rocosas espectaculares.',
    depth: '15m',
    vis: '40m+'
  }, {
    name: 'Caverna da Sapata',
    desc: 'Una cueva inmensa donde habitan meros gigantes y rayas.',
    depth: '28m',
    vis: '30m+'
  }];
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = window.innerWidth > 768 ? 400 : 300;
      scrollRef.current.scrollBy({
        left: dir === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section id="buceo" className="py-24 md:py-32 bg-noronha-volcanic overflow-hidden" data-id="element-100">
      <div className="container mx-auto px-6 mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6" data-id="element-101">
        <SectionHeader eyebrow="Exploración" title="Puntos de buceo destacados" align="left" className="max-w-2xl" data-id="element-102" />
        <div className="flex gap-3" data-id="element-103">
          <button onClick={() => scroll('left')} className="p-3 rounded-full border border-noronha-petroleum hover:bg-noronha-petroleum/20 transition-colors text-noronha-text-heading" data-id="element-104">
            <ArrowLeft className="w-5 h-5" data-id="element-105" />
          </button>
          <button onClick={() => scroll('right')} className="p-3 rounded-full border border-noronha-petroleum hover:bg-noronha-petroleum/20 transition-colors text-noronha-text-heading" data-id="element-106">
            <ArrowRight className="w-5 h-5" data-id="element-107" />
          </button>
        </div>
      </div>

      <div ref={scrollRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory no-scrollbar px-6 md:px-12 pb-12" style={{
      scrollPaddingLeft: '1.5rem'
    }} data-id="element-108">
        {spots.map((spot, idx) => <div key={idx} className="min-w-[85vw] md:min-w-[400px] snap-start shrink-0" data-id="element-109">
            <Placeholder type="image" aspectRatio="video" label={`Spot: ${spot.name}`} className="mb-6 rounded-2xl" data-id="element-110" />
            <h3 className="text-2xl font-heading text-noronha-text-heading mb-2" data-id="element-111">
              {spot.name}
            </h3>
            <p className="text-noronha-text-body mb-4" data-id="element-112">{spot.desc}</p>
            <div className="flex gap-4 font-mono text-xs text-noronha-gold uppercase tracking-wider" data-id="element-113">
              <span data-id="element-114">Prof: {spot.depth}</span>
              <span data-id="element-115">•</span>
              <span data-id="element-116">Vis: {spot.vis}</span>
            </div>
          </div>)}
      </div>
    </section>;
}
export function Fauna() {
  const fauna = [{
    name: 'Tiburón Limón',
    label: 'Depredador Residente'
  }, {
    name: 'Tortuga Verde',
    label: 'Santuario Natural'
  }, {
    name: 'Delfín Rotador',
    label: 'Encuentros Diarios'
  }, {
    name: 'Manta Raya',
    label: 'Gigantes del Océano'
  }, {
    name: 'Mero Gigante',
    label: 'Guardianes del Arrecife'
  }, {
    name: 'Raya Águila',
    label: 'Vuelo Submarino'
  }];
  return <section className="py-24 md:py-32 bg-noronha-graphite/30" data-id="element-117">
      <div className="container mx-auto px-6" data-id="element-118">
        <SectionHeader eyebrow="Biodiversidad" title="Fauna que podrás encontrar" description="Noronha es un oasis de vida pelágica y macro en el medio del océano." className="mb-16" data-id="element-119" />

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-120">
          {fauna.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="group relative overflow-hidden rounded-2xl aspect-[3/4] md:aspect-square" data-id="element-121">
              <Placeholder type="image" aspectRatio="auto" label="Fauna Image" className="absolute inset-0 w-full h-full rounded-2xl border-none" data-id="element-122" />
              <div className="absolute inset-0 bg-gradient-to-t from-noronha-volcanic via-noronha-volcanic/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" data-id="element-123" />
              <div className="absolute bottom-0 left-0 p-6 w-full" data-id="element-124">
                <p className="font-mono text-[10px] md:text-xs text-noronha-emerald uppercase tracking-widest mb-1" data-id="element-125">
                  {item.label}
                </p>
                <h3 className="text-lg md:text-xl font-heading text-noronha-text-heading" data-id="element-126">
                  {item.name}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export function Gallery() {
  return <section className="py-24 bg-noronha-volcanic border-t border-noronha-petroleum/20" data-id="element-127">
      <div className="container mx-auto px-6" data-id="element-128">
        <SectionHeader eyebrow="Visuales" title="La Experiencia en Imágenes" className="mb-16" data-id="element-129" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-130">
          <Placeholder type="gallery" aspectRatio="square" className="col-span-2 row-span-2" label="Hero Gallery Image" data-id="element-131" />
          <Placeholder type="gallery" aspectRatio="square" label="Gallery Image 1" data-id="element-132" />
          <Placeholder type="gallery" aspectRatio="square" label="Gallery Image 2" data-id="element-133" />
          <Placeholder type="gallery" aspectRatio="square" label="Gallery Image 3" data-id="element-134" />
          <Placeholder type="gallery" aspectRatio="square" label="Gallery Image 4" data-id="element-135" />
        </div>
      </div>
    </section>;
}